import API from "../../axios.jsx";

const BASE = "/bac/auth";

export const loginBac           = (correo, password) => API.post(`${BASE}/login`, { correo, password });
export const registrarUsuarioBac       = (datos) => API.post(`${BASE}/registro`, datos);
export const restablecerPasswordBac    = (datos) => API.post(`${BASE}/restablecer`, datos);

export const listarUsuariosBac  = () => API.get(`${BASE}/usuarios`);
export const crearUsuarioBac    = (datos) => API.post(`${BASE}/usuarios`, datos);
export const editarUsuarioBac   = (id, datos) => API.put(`${BASE}/usuarios/${id}`, datos);
export const eliminarUsuarioBac = (id) => API.delete(`${BASE}/usuarios/${id}`);